import {
  Link,
  Wrapper,
  Image,
  ConnectionView,
  Icon,
  ExtensionView,
  SessionRole,
  IphoneRelayView,
} from "nystem-components";

const PartMenu = () => (
  <Wrapper
    renderAs="nav"
    className="fixed top-0 z-20 flex h-12 w-full max-w-xl items-center gap-4 bg-gray-900 px-4 text-gray-100 sm:gap-6 sm:px-6"
  >
    <Link className="flex h-full shrink-0 items-center" to="/" match="/" exact={true}>
      <ConnectionView>
        <Image className="text-red py-1" width={40} height={30} src="/image/remotor.svg" alt="logo" />
      </ConnectionView>
      <ConnectionView offline="true">
        <Image className="text-red py-1 grayscale" width={40} height={30} src="/image/remotor.svg" alt="logo" />
      </ConnectionView>
    </Link>
    <Wrapper className="ml-auto flex h-full shrink-0 items-center">
      <SessionRole userrole="logged-in">
        <IphoneRelayView />
        <Link className="border-hover mx-1 py-2 text-center" to="/event/list" match="/event*">
          <Icon icon="circle-radiation" className="h-8 w-8 p-1" />
        </Link>
        <Link className="border-hover mx-1 py-2 text-center" to="/device/overview" match="/device/overview*">
          <Icon icon="lightbulb" className="h-8 w-8 p-1" />
        </Link>
        <Link className="border-hover mx-1 py-2 text-center" to="/remotorapp/settings/desktop" match="/remotorapp/*">
          <Icon icon="desktop" className="h-8 w-8 p-1" />
        </Link>
        <Link className="border-hover mx-1 py-2 text-center" to="/driveSync/list" match="/drive*">
          <Icon icon="copy" className="h-8 w-8 p-1" />
        </Link>
      </SessionRole>
      <ExtensionView>
        <a
          className="border-hover mx-1 py-2 text-center"
          href="https://35f3478.remotor.mimicme.se/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon icon="up-right-from-square" className="h-8 w-8 p-1" />
        </a>
      </ExtensionView>
      <Icon icon="square" className="hidden" />
      <Icon icon="xmark" className="hidden" />
    </Wrapper>
  </Wrapper>
);

export default PartMenu;
/*
      <Link
        className="py-2 border-hover mx-1 w-16 text-center"
        to="/mediaFile/list"
        match="/mediaFile/*"
      >
        VLC
      </Link>
*/
